import { RestApiResponse } from "../../Models/RestApiResponse";
import { User } from "../../Models/User";
import { getUserData } from "../../Services/DealerAdminService";
import { loggedIn, notAuthorised } from "./UserAuthActions";

export const getUserDetails = () => (dispatch: any) => {
  getUserData().then((response: RestApiResponse) => {
    if (response.success) {
      const data = response.data as User;
      dispatch(loggedIn(data));
    } else {
      const errorCode = response.errorCode
        ? response.errorCode
        : "GetUserError";

      dispatch(notAuthorised());
    }
  });
};
